import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconsList = (props) => {
  const {
    colourScheme,
    iconRows,
    direction,
    titleColour,
    title,
    text,
    breakPoint,
    rowsNumber,
    alignment,
    customPadding
  } = props;

  const componentClasses = classNames('iconList', {
    [`iconList--break-${breakPoint}`]: breakPoint,
    'iconList--break-mw': !breakPoint,
    [`iconList--${colourScheme}-scheme`]: colourScheme,
    [`titles--${titleColour}`]: titleColour,
    [`iconList--${direction}-direction`]: direction,
    [`iconList--${rowsNumber}-rows`]: rowsNumber,
    [`iconList--${alignment}-align`]: alignment,
    'iconList--no-padding-top': customPadding === 'no-top',
    'iconList--no-padding-bottom': customPadding === 'no-bottom',
    'iconList--no-padding-top-bottom': customPadding === 'no-padding'
  });

  const parseContent = ({ src, text }) => {
    return src ? props[src] : `<p>${text}</p>`;
  };

  return (
    <section className={componentClasses}>
      {title && <h2 className="iconList-title">{title}</h2>}
      {text && <p className="text-content__inner">{text}</p>}
      <div className="iconList-container">
        {iconRows
          ? iconRows.map((iconRow) => (
              <div key={iconRow.src || iconRow.text} className="iconRow">
                {iconRow.icon ? <span className={`iconList--Icon ${iconRow.icon}`} /> : null}
                {iconRow.label ? (
                  <p>
                    <strong>{iconRow.label}</strong>
                  </p>
                ) : null}
                {iconRow.bigIcon ? <span className={iconRow.bigIcon} /> : null}
                {iconRow.src || iconRow.text ? (
                  <article dangerouslySetInnerHTML={{ __html: parseContent(iconRow) }} />
                ) : null}
              </div>
            ))
          : null}
      </div>
    </section>
  );
};

IconsList.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  breakPoint: PropTypes.string,
  rowsNumber: PropTypes.string,
  iconRows: PropTypes.array,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
  colourScheme: PropTypes.oneOf([
    'grey',
    'dark-navy',
    'light-grey',
    'gradient',
    'teal',
    'teal-in-navy',
    'teal-in-teal',
    'sand',
    'neutral-navy'
  ]),
  titleColour: PropTypes.oneOf(['purple', 'dark-navy', 'teal']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding'])
};

export default IconsList;
